<p>
  bad-request works!
</p>
<div style="text-align: center; font-weight: bold; font-size: 18px;">
  <img src="assets/images/imgError400.png" alt="Error 400" style="max-width: 100%; height: auto;">
  <p>400 Bad Request</p>
  <p>Server didn't understand the URL you gave it.</p>
</div>
